import getters from './getters'
import actions from './actions'
import state from './state'

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations: {
      RESET_CARS(state) {
        state.cars.scrollTop = 0
            //state.cars.filters = state.cars.filters,
        state.cars.items = []
        state.cars.loaded = false
      }
    }
}